import comp from "./AddAttachment";
export default comp;
